import { Injectable } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { SectionIds } from '../../../../../../aumico-lib-annualreport-fe/src/lib';
import { ArFeatureBaseModel } from '../../../_base/arFeatureBase.model';
import { ArFeatureBasePDFSectionFactory } from '../../../_base/arFeatureBasePdfSection.factory';
import { FcpPDFSectionFactory } from '../financial-closing-process/adapters/outbound/fcp.pdfsection.factory';
@Injectable({
    providedIn: 'root',
})
export class SectionFactoryService {
    private factoryMap = new Map<string, ArFeatureBasePDFSectionFactory<ArFeatureBaseModel>>();

    constructor(i18nextService: I18NextService) {
        this.registerFactory(SectionIds.FINANCIAL_CLOSING_PROCESS, new FcpPDFSectionFactory(i18nextService));
        //this.registerFactory('income', new IncomeStatementSectionFactory());
        // Register other factories
    }

    registerFactory(type: string, factory: ArFeatureBasePDFSectionFactory<ArFeatureBaseModel>): void {
        this.factoryMap.set(type, factory);
    }

    getFactory(type: string): ArFeatureBasePDFSectionFactory<ArFeatureBaseModel> {
        return this.factoryMap.get(type);
    }
}
